// eslint-disable
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const en_widget_leaderboard_top_teams = /** @type {(inputs: {}) => string} */ () => {
	return `Top Teams`
};

const de_widget_leaderboard_top_teams = /** @type {(inputs: {}) => string} */ () => {
	return `Top Teams`
};

const es_widget_leaderboard_top_teams = /** @type {(inputs: {}) => string} */ () => {
	return `Mejores Equipos`
};

const fr_widget_leaderboard_top_teams = /** @type {(inputs: {}) => string} */ () => {
	return `Meilleures équipes`
};

const fi_widget_leaderboard_top_teams = /** @type {(inputs: {}) => string} */ () => {
	return `Parhaat Joukkueet`
};

const hi_widget_leaderboard_top_teams = /** @type {(inputs: {}) => string} */ () => {
	return `शीर्ष टीमें`
};

const ja_widget_leaderboard_top_teams = /** @type {(inputs: {}) => string} */ () => {
	return `トップチーム`
};

const nl_widget_leaderboard_top_teams = /** @type {(inputs: {}) => string} */ () => {
	return `Top Teams`
};

const pt_widget_leaderboard_top_teams = /** @type {(inputs: {}) => string} */ () => {
	return `Melhores Equipas`
};

const ro_widget_leaderboard_top_teams = /** @type {(inputs: {}) => string} */ () => {
	return `Echipele de Top`
};

const th_widget_leaderboard_top_teams = /** @type {(inputs: {}) => string} */ () => {
	return `ทีมชั้นนำ`
};

const ur_widget_leaderboard_top_teams = /** @type {(inputs: {}) => string} */ () => {
	return `بہترین ٹیمیں`
};

const zh_hant1_widget_leaderboard_top_teams = /** @type {(inputs: {}) => string} */ () => {
	return `頂級團隊`
};

const da_widget_leaderboard_top_teams = /** @type {(inputs: {}) => string} */ () => {
	return `Top Hold`
};

const it_widget_leaderboard_top_teams = /** @type {(inputs: {}) => string} */ () => {
	return `Top Squadre`
};

const vn_widget_leaderboard_top_teams = /** @type {(inputs: {}) => string} */ () => {
	return `Đội Hàng Đầu`
};

const ko_widget_leaderboard_top_teams = /** @type {(inputs: {}) => string} */ () => {
	return `최고 팀들`
};

const tr_widget_leaderboard_top_teams = /** @type {(inputs: {}) => string} */ () => {
	return `En İyi Takımlar`
};

const lv_widget_leaderboard_top_teams = /** @type {(inputs: {}) => string} */ () => {
	return `Labākās Komandas`
};

const ar_widget_leaderboard_top_teams = /** @type {(inputs: {}) => string} */ () => {
	return `أفضل الفرق`
};

const bs_widget_leaderboard_top_teams = /** @type {(inputs: {}) => string} */ () => {
	return `Najbolji Timovi`
};

const sl_widget_leaderboard_top_teams = /** @type {(inputs: {}) => string} */ () => {
	return `Najboljše Ekipe`
};

const id_widget_leaderboard_top_teams = /** @type {(inputs: {}) => string} */ () => {
	return `Tim Teratas`
};

const sv_widget_leaderboard_top_teams = /** @type {(inputs: {}) => string} */ () => {
	return `Toppar lag`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "fi" | "hi" | "ja" | "nl" | "pt" | "ro" | "th" | "ur" | "zh-Hant" | "da" | "it" | "vn" | "ko" | "tr" | "lv" | "ar" | "bs" | "sl" | "id" | "sv" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const widget_leaderboard_top_teams = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.widget_leaderboard_top_teams(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("widget_leaderboard_top_teams", locale)
	if (locale === "en") return en_widget_leaderboard_top_teams(inputs)
	if (locale === "de") return de_widget_leaderboard_top_teams(inputs)
	if (locale === "es") return es_widget_leaderboard_top_teams(inputs)
	if (locale === "fr") return fr_widget_leaderboard_top_teams(inputs)
	if (locale === "fi") return fi_widget_leaderboard_top_teams(inputs)
	if (locale === "hi") return hi_widget_leaderboard_top_teams(inputs)
	if (locale === "ja") return ja_widget_leaderboard_top_teams(inputs)
	if (locale === "nl") return nl_widget_leaderboard_top_teams(inputs)
	if (locale === "pt") return pt_widget_leaderboard_top_teams(inputs)
	if (locale === "ro") return ro_widget_leaderboard_top_teams(inputs)
	if (locale === "th") return th_widget_leaderboard_top_teams(inputs)
	if (locale === "ur") return ur_widget_leaderboard_top_teams(inputs)
	if (locale === "zh-Hant") return zh_hant1_widget_leaderboard_top_teams(inputs)
	if (locale === "da") return da_widget_leaderboard_top_teams(inputs)
	if (locale === "it") return it_widget_leaderboard_top_teams(inputs)
	if (locale === "vn") return vn_widget_leaderboard_top_teams(inputs)
	if (locale === "ko") return ko_widget_leaderboard_top_teams(inputs)
	if (locale === "tr") return tr_widget_leaderboard_top_teams(inputs)
	if (locale === "lv") return lv_widget_leaderboard_top_teams(inputs)
	if (locale === "ar") return ar_widget_leaderboard_top_teams(inputs)
	if (locale === "bs") return bs_widget_leaderboard_top_teams(inputs)
	if (locale === "sl") return sl_widget_leaderboard_top_teams(inputs)
	if (locale === "id") return id_widget_leaderboard_top_teams(inputs)
	if (locale === "sv") return sv_widget_leaderboard_top_teams(inputs)
	return "widget_leaderboard_top_teams"
};